// extracted by mini-css-extract-plugin
export default {"container":"selection_container__RHZFV","label":"selection_label__xsgIW","icon":"selection_icon__0S3IK","img":"selection_img__6y5H8"};